import { render, staticRenderFns } from "./CodeList.vue?vue&type=template&id=83793898&scoped=true&"
import script from "./CodeList.vue?vue&type=script&lang=ts&"
export * from "./CodeList.vue?vue&type=script&lang=ts&"
import style0 from "./CodeList.vue?vue&type=style&index=0&id=83793898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83793898",
  null
  
)

component.options.__file = "CodeList.vue"
export default component.exports